import _APIInstance from "@/config/configApi";
import _APIInstanceServer from "@/config/configApiServer";
import {
  paramsLang,
  paramsSubcription,
  paramsSubscription,
} from "@/models/Params";
import { subscription } from "@/models/subscription";
import { API } from "@constants/common";

export default class SubscriptionServices {
  static async getOneSubscription(
    id: number | string | null,
    params: paramsLang | null,
  ) {
    return _APIInstance
      .get(`${API.SUBSCRIPTION.GET_ONE}`.replace(":id", `${id}`), {
        params: params,
      })
      .then((res) => Promise.resolve(res.data))
      .catch((res) => Promise.reject(res.response.data));
  }

  static async getTrial() {
    return _APIInstance
      .get(API.SUBSCRIPTION.GET_TRIAL)
      .then((res) => Promise.resolve(res.data?.data))
      .catch((res) => Promise.reject(res.response?.data));
  }

  static async getTrialServer() {
    try {
      const response = await _APIInstanceServer.get(API.SUBSCRIPTION.GET_TRIAL);
      return response.data?.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  }

  static async createNeedHelp(data: any) {
    return _APIInstance
      .post(API.SUBSCRIPTION.CREATE_NEED_HELP, data)
      .then((res) => Promise.resolve(res.data))
      .catch((res) => Promise.reject(res.response.data));
  }

  static async getOneSubscriptionServer(
    id: number | string | null,
    params: paramsLang | null,
  ) {
    try {
      const response = await _APIInstanceServer.get(
        `${API.SUBSCRIPTION.GET_ONE}`.replace(":id", `${id}`),
        {
          params: params,
        },
      );
      return response.data?.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  }

  static async getSubscriptions(params: paramsSubcription) {
    return _APIInstance
      .get(`${API.SUBSCRIPTION.GET_ALL}`, {
        params: params,
        headers: {
          lang: params?.language || "en",
        },
      })
      .then((res) => Promise.resolve(res.data?.data))
      .catch((res) => Promise.reject(res.response.data));
  }

  static async getOneSubscriptionMin(params: paramsSubscription | null) {
    return _APIInstance
      .get(`${API.SUBSCRIPTION.GET_ONE_MIN}`, { params: params })
      .then((res) => Promise.resolve(res.data?.data))
      .catch((res) => Promise.reject(res.response.data));
  }

  static async getAllSubscriptionsByUserId(
    userId: number | string | undefined,
    params?: paramsLang | null,
  ) {
    return _APIInstance
      .get(
        `${API.SUBSCRIPTION.GET_ALL_BY_USER_ID}`.replace(":id", `${userId}`),
        { params: params },
      )
      .then((res) => Promise.resolve(res.data?.data))
      .catch((res) => Promise.reject(res.response.data));
  }

  static async getAllSubscriptionsByUserIdServer(
    userId: number | string | undefined,
    params?: paramsLang | null,
  ) {
    return _APIInstanceServer
      .get(
        `${API.SUBSCRIPTION.GET_ALL_BY_USER_ID}`.replace(":id", `${userId}`),
        { params: params },
      )
      .then((res) => Promise.resolve(res.data?.data))
      .catch((res) => Promise.reject(res.response.data));
  }

  static async addSubscriber(data: any) {
    return _APIInstance
      .post(API.SUBSCRIBER.ADD_MEMBER, data)
      .then((res) => Promise.resolve(res.data))
      .catch((res) => Promise.reject(res.response.data));
  }

  static async findByIds(data: number[]): Promise<subscription[]> {
    return await _APIInstance
      .get(`${API.SUBSCRIPTION.GET_BY_IDS}?params=${data.join(",")}`)
      .then((res) => {
        return Promise.resolve(res.data.data);
      })
      .catch((e) => {
        return Promise.reject(e?.response?.data);
      });
  }

  // static async findByIdsSever (data: number[]) {
  //   return _APIInstanceServer.post(API.SUBSCRIPTION.GET_BY_IDS, data)
  //     .then((res) => Promise.resolve(res.data))
  //     .catch((res) => Promise.reject(res.response.data));
  // }

  static async findByIdsSever(data: number[]) {
    try {
      const response = await _APIInstanceServer.get(
        `${API.SUBSCRIPTION.GET_BY_IDS}?params=${data.join(",")}`,
      );
      return response.data.data;
    } catch (error: any) {
      throw error?.response?.data;
    }
  }
}
